import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LayoutComponent } from './layout.component';

import { OnscreenNotificationModule } from '@fleet/ui/onscreen-notification/onscreen-notification.module';
import { EmptyLayoutModule } from './layouts/empty/empty.module';
import { FleetFlexLayoutModule } from './layouts/fleet-flex-layout/fleet-flex-layout.module';
import { FleetLayoutModule } from './layouts/fleet-layout/fleet-layout.module';
import { FleetTravellerLayoutModule } from './layouts/fleet-traveller-layout/fleet-traveller-layout.module';
import { KioskLayoutModule } from './layouts/kiosk-layout/kiosk-layout.module';
import { NativeAppWebviewLayoutModule } from './layouts/native-app-webview-layout/native-app-webview-layout.module';

export const lazyTranslationloader = ['en_au', 'es', 'en_us'].reduce(
  (acc: { [key: string]: () => Promise<any> }, lang) => {
    acc[lang] = () => import(`./i18n/${lang}.json`);
    return acc;
  },
  {}
);

@NgModule({
  declarations: [LayoutComponent],
  imports: [
    CommonModule,
    FleetLayoutModule,
    OnscreenNotificationModule,
    EmptyLayoutModule,
    NativeAppWebviewLayoutModule,
    FleetTravellerLayoutModule,
    KioskLayoutModule,
    FleetFlexLayoutModule,
  ],
  exports: [LayoutComponent],
  providers: [
    // provideTranslocoScope({
    //   scope: 'navigation',
    //   loader: lazyTranslationloader,
    // }),
  ],
})
export class LayoutModule {}
